import { Workflow } from 'lucide-react';
import type { NavbarTab } from './app-navbar';

export const OPERATIONS_SIDEBAR = {
  title: 'Operations',
  subtitle: 'Monitor pipelines and operational data',
  color: 'bg-gray-600',
  icon: <Workflow className="size-[18px] stroke-white" />,
  path: '/operations',
};

export const OPERATIONS_TABS: NavbarTab[] = [
  {
    id: 'etl',
    key: 'ALL',
    label: 'ETL',
  },
  {
    id: 'scheduler',
    key: 'scheduler',
    label: 'Schedules',
  },
  {
    id: 'data-transfers',
    key: 'data-transfers',
    label: 'Data Transfers',
  },
  {
    id: 'settings',
    key: 'settings',
    label: 'Settings',
  },
  {
    id: 'apis',
    key: 'apis',
    label: 'APIs',
  },
  {
    id: 'usage-insights',
    key: 'usage-insights',
    label: 'Usage Insights',
  },
];

export const OPERATIONS_DEFAULT_TAB = OPERATIONS_TABS[0]?.id ?? 'etl';

export const OPERATIONS_TAB_IDS = OPERATIONS_TABS.map((tab) => tab.id);
